module.exports = __webpack_public_path__ + "static/media/closeLogin.3968ed62.svg";